import { useRecoilValue } from 'recoil'

import { $measurementUnit, $measurementUnitsList } from './selectors'

/**
 * returns a collection of all available measurement unit conversions
 * that are available for the current tenant
 */
export function useMeasurementUnit() {
  const muConversions = useRecoilValue($measurementUnit)
  return muConversions
}

export function useMeasurementUnitsList() {
  const list = useRecoilValue($measurementUnitsList)
  return list
}
